import { PageTitle } from "@app/components/common/PageTitle/PageTitle";
import { ReportCategories } from "@app/components/eMIPs/Reports/ReportCategories";
import { useTranslation } from "react-i18next";

export const ListReportCategoriesPage: React.FC = () => {
    const { t } = useTranslation();
    return (
        <>
            <PageTitle>{t('reports.listReportCategories')}</PageTitle>
            <ReportCategories />
        </>
    );
};